import { Box, Typography } from '@mui/material';
import { ScenarioStat } from 'types';

interface ScenarioBreakdownProps {
  data: ScenarioStat[];
}

export default function ScenarioBreakdown({ data }: ScenarioBreakdownProps) {
  const max = Math.max(...data.map((d) => d.requests));

  return (
    <Box
      sx={{
        background: '#FFFFFF',
        border: '1px solid rgba(20,116,255,0.10)',
        boxShadow: '0 2px 16px rgba(20,116,255,0.08), 0 1px 4px rgba(0,0,0,0.03)',
        borderRadius: 'var(--radius-lg)',
        p: 2.5,
        transition: 'box-shadow 0.20s ease',
        '&:hover': { boxShadow: '0 4px 24px rgba(20,116,255,0.12), 0 1px 4px rgba(0,0,0,0.04)' },
      }}
    >
      <Typography
        sx={{
          fontSize: 11,
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '0.07em',
          color: 'var(--color-text-muted)',
          mb: 2,
        }}
      >
        По сценариям
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        {data.map((d) => (
          <Box key={d.scenarioId} sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Typography
              sx={{
                fontSize: 12,
                color: 'var(--color-text-secondary)',
                width: 120,
                flexShrink: 0,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {d.title}
            </Typography>
            <Box
              sx={{
                flex: 1,
                height: 6,
                background: 'rgba(20,116,255,0.08)',
                borderRadius: '3px',
                overflow: 'hidden',
              }}
            >
              <Box
                sx={{
                  height: '100%',
                  borderRadius: '3px',
                  width: `${(d.requests / max) * 100}%`,
                  background: 'linear-gradient(90deg, #1474FF, #3B8BFF)',
                }}
              />
            </Box>
            <Typography
              sx={{
                fontSize: 12,
                color: 'var(--color-primary)',
                fontWeight: 700,
                width: 28,
                textAlign: 'right',
                flexShrink: 0,
              }}
            >
              {d.requests}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
